import { FlyoutMenuAction, FlyoutMenuOption } from "@app/shared/components/flyout-menu/flyout-menu.component";
import { CHDbObject, DbHelper } from "@app/shared/model/db-object.model";
import { ClassImporterExporter, ImportMap } from "@app/shared/resources/class-importer-exporter.service";

export enum ConditionProviders {
    ASTRO_TIMER = "AstroTimerCondition",
    ABSOLUTE_TIMER = "AbsoluteTimerCondition",
    DAILY_TIMER = "DailyTimerCondition",
    DAILY_PERIOD = "DailyPeriodCondition",
    MULTI = "MultiCondition",
    PROPERTY_CHANGE = "PropertyChangeCondition",
    UI_CONDITION = "UICondition",
    CUSTOM_BUTTON = "CustomButtonCondition",
    EVENT = "EventCondition",
    LOGIC = "LogicCondition",
    STATUS = "StatusCondition",
    RC_CONDITION = "RCCondition",
}

export interface EventHandlers {
    edit?: FlyoutMenuAction;
    remove?: FlyoutMenuAction;
}

export interface Condition {
    name: string;
    conditionId: string;
    conditionType: string;
    conditionHelper?: ConditionHelper;
    flyoutMenuActions?: FlyoutMenuAction[];
    controlPointId?: string;
}

export interface ConditionData extends CHDbObject {
    name: string;
    condition_id: string;
    condition_type: string;
}

export abstract class ConditionHelper extends DbHelper<any, any> {
    static readonly importMap: ImportMap<any, any> = [
        { i: "name", o: "name" },
        { i: "condition_id", o: "conditionId" },
        { i: "condition_type", o: "conditionType" },
    ];

    static fromCHObject(condition): any {
        return {
            name: condition[this.importMap[0].i],
            conditionId: condition[this.importMap[1].i] === undefined ? null : condition[this.importMap[1].i],
            conditionType: condition[this.importMap[2].i],
        };
    }

    static registerEventHandlers(handlers: EventHandlers): FlyoutMenuOption[] {
        const flyoutMenuActions: FlyoutMenuOption[] = [];

        if (handlers.edit) {
            flyoutMenuActions.push({ name: $localize`:@@SHARED.BTN.EDIT:Edit`, action: handlers.edit });
        }

        if (handlers.remove) {
            flyoutMenuActions.push({ name: $localize`:@@SHARED.BTN.REMOVE:Remove`, action: handlers.remove });
        }

        return flyoutMenuActions;
    }

    static isValid(condition: Condition): boolean {
        return !!condition;
    }

    static getDefault(param?: any): Condition {
        return {
            name: null,
            conditionId: null,
            conditionType: null,
        };
    }

    static exportObject(condition, importMap) {
        return ClassImporterExporter.exportObject(condition, importMap, false);
    }

    constructor() {
        super();
    }
}
